import styled from "@emotion/styled";

import { FONT_WEIGHT_BOLD, FONT_WEIGHT_NORMAL, SkiliticsDots } from "@skilitics/designer-ui-components";
import { useFormatMessage, type FormatMessages } from "@skilitics/localization";

const ViewContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  width: 100%;
  height: 100%;
  min-height: 400px;

  perspective: 600px;
`;

const Container = styled.div`
  position: relative;

  display: flex;
  flex-direction: column;
`;

const DetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  gap: 5px;

  width: 100%;

  font-size: 14px;
  color: ${({ theme }) => theme.generalTextIcon};

  opacity: 0.5;
  padding: 25px 0;
  overflow: hidden;
`;

const Title = styled.div`
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;

  font-weight: ${FONT_WEIGHT_BOLD};

  overflow: hidden;
`;

const Description = styled.div`
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;

  font-size: 12px;
  font-weight: ${FONT_WEIGHT_NORMAL};

  overflow: hidden;
`;

export const LoadingView = () => {
  const formatMessage = useFormatMessage(formatStrings);

  return (
    <ViewContainer data-test="loading-view-container">
      <Container>
        <SkiliticsDots busy={true} />
        <DetailsContainer>
          <Title>{formatMessage("title")}</Title>
          <Description>{formatMessage("description")}</Description>
        </DetailsContainer>
      </Container>
    </ViewContainer>
  );
};

const formatStrings = {
  title: {
    en: "Loading Modules...",
  },
  description: {
    en: "Retrieving the list of available modules.",
  },
  loading: {
    en: "Loading Modules",
  },
} satisfies FormatMessages;
